/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DevelopmentRegistrationStep = "first_buyer" | "result" | "second_buyer" | "verification";
export type UpsertDevelopmentRegistrationFormInput = {|
  developmentRegistrationForm?: ?DevelopmentRegistrationFormInput,
  clientMutationId?: ?string,
|};
export type DevelopmentRegistrationFormInput = {|
  id?: ?string,
  productId?: ?string,
  developmentProductId?: ?string,
  firstBuyerFirstName?: ?string,
  firstBuyerLastName?: ?string,
  firstBuyerEmailAddress?: ?string,
  firstBuyerPhoneNumber?: ?string,
  emailAddress?: ?string,
  phoneNumber?: ?string,
  numberOfBuyers?: ?number,
  isAlreadyOwner?: ?boolean,
  inviteSecondBuyer?: ?boolean,
  firstBuyerDateOfBirth?: ?string,
  firstBuyerOccupationId?: ?string,
  firstBuyerNationalityId?: ?string,
  firstBuyerWorkPermitId?: ?string,
  firstBuyerAnnualRevenues?: ?number,
  firstBuyerSavings?: ?number,
  firstBuyerUseOfSecondPillar?: ?boolean,
  firstBuyerSecondPillar?: ?number,
  firstBuyerUseOfThirdPillar?: ?boolean,
  firstBuyerThirdPillar?: ?number,
  secondBuyerFirstName?: ?string,
  secondBuyerLastName?: ?string,
  secondBuyerEmailAddress?: ?string,
  secondBuyerPhoneNumber?: ?string,
  secondBuyerDateOfBirth?: ?string,
  secondBuyerOccupationId?: ?string,
  secondBuyerNationalityId?: ?string,
  secondBuyerWorkPermitId?: ?string,
  secondBuyerAnnualRevenues?: ?number,
  secondBuyerSavings?: ?number,
  secondBuyerUseOfSecondPillar?: ?boolean,
  secondBuyerSecondPillar?: ?number,
  secondBuyerUseOfThirdPillar?: ?boolean,
  secondBuyerThirdPillar?: ?number,
  maximumBudget?: ?number,
  buyApartment?: ?boolean,
  buyHouse?: ?boolean,
  minNumberOfBedrooms?: ?number,
  buyGroundFloor?: ?boolean,
  buyIntermediateFloor?: ?boolean,
  buyTopFloor?: ?boolean,
  hasLandForSale?: ?boolean,
  step?: ?DevelopmentRegistrationStep,
|};
export type DevelopmentConfirmationStepUpsertFormMutationVariables = {|
  input: UpsertDevelopmentRegistrationFormInput
|};
export type DevelopmentConfirmationStepUpsertFormMutationResponse = {|
  +upsertDevelopmentRegistrationForm: ?{|
    +form: ?{|
      +id: string,
      +hasLandForSale: ?boolean,
      +developmentProduct: ?{|
        +id: string,
        +slug: string,
        +title: ?string,
      |},
    |}
  |}
|};
export type DevelopmentConfirmationStepUpsertFormMutation = {|
  variables: DevelopmentConfirmationStepUpsertFormMutationVariables,
  response: DevelopmentConfirmationStepUpsertFormMutationResponse,
|};
*/


/*
mutation DevelopmentConfirmationStepUpsertFormMutation(
  $input: UpsertDevelopmentRegistrationFormInput!
) {
  upsertDevelopmentRegistrationForm(input: $input) {
    form: developmentRegistrationForm {
      id
      hasLandForSale
      developmentProduct {
        id
        slug
        title
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertDevelopmentRegistrationFormPayload",
    "kind": "LinkedField",
    "name": "upsertDevelopmentRegistrationForm",
    "plural": false,
    "selections": [
      {
        "alias": "form",
        "args": null,
        "concreteType": "DevelopmentRegistrationForm",
        "kind": "LinkedField",
        "name": "developmentRegistrationForm",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasLandForSale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DevelopmentProduct",
            "kind": "LinkedField",
            "name": "developmentProduct",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DevelopmentConfirmationStepUpsertFormMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DevelopmentConfirmationStepUpsertFormMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2c25934222c3ffee04fa7ca9323c7021",
    "id": null,
    "metadata": {},
    "name": "DevelopmentConfirmationStepUpsertFormMutation",
    "operationKind": "mutation",
    "text": "mutation DevelopmentConfirmationStepUpsertFormMutation(\n  $input: UpsertDevelopmentRegistrationFormInput!\n) {\n  upsertDevelopmentRegistrationForm(input: $input) {\n    form: developmentRegistrationForm {\n      id\n      hasLandForSale\n      developmentProduct {\n        id\n        slug\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'de1dea066306453cf17f4da12cad663b';

export default node;
